import { CacheService } from "../../../Components/Http/Cache/CacheService";

(function ($) {

    var setupBankAccountPopup = function (model, OnSuccessCallback) {
        this.profileRequest = new $.cdh.get.profile.get();
        this.setupBankAccountModel = ko.observable();
        this.isProceedToSetup = ko.observable(false);

        this.loadProfile = () => {
            this.profileRequest.load({ ticket: $.cdh.user.ticket }).done((data) => {
                const modelInstance = new $.cdh.models.ProfileReimbursementMethodEditPopup(data, true, $.noop, this.reloadAccountActivityOnSuccess);
                modelInstance.preRender();
                modelInstance.isRoutedFromAccountSetup(true);
                modelInstance.titleText = ko.pureComputed(() =>
                    $.cdh.languageConstant.getConstant('title.payment-type')
                );

                modelInstance.setClose(() => {
                    this.isProceedToSetup(false);
                    this.clickCancel();
                });

                this.setupBankAccountModel(modelInstance);
            });
        };

        this.clickCancel = () => this.close();
        this.clickSubmit = () => this.isProceedToSetup(true);

        this.setClose = (closeFunc) => {
            this.close = () => closeFunc.call(this);
        };

        this.closeModel = () => this.isProceedToSetup(false);

        // Added for call back once the user has successfully setup the bank account
        // through Account activity flow the page should be reloaded to show 
        // the updated information by clearing only the profile cache.
        // insted of opening the setup bank account popup again.
        this.reloadAccountActivityOnSuccess = () => {
            new CacheService().clearAsync(4, {}).done(window.location.reload());
        }

        // Initialize by loading profile
        this.loadProfile();
    };

    $.extend(true, $, {
        cdh: {
            models: {
                SetupBankAccount: setupBankAccountPopup
            }
        }
    });
}(jQuery));